import { useLocation, useParams } from "react-router-dom";
import ProductCardStyleOne from "../Helpers/Cards/ProductCardStyleOne";
import CountDown from "../Helpers/CountDown";
import Layout from "../Partials/Layout";
import ProductServices from "../../apis/product/ProductServices";
import { useEffect, useState } from "react";
import { ErrorToaster } from "../Helpers/toaster/Toaster";

export default function FlashSale() {

  const { id } = useParams();
  const { state } = useLocation();

  const { showDays, showHours, showMinutes, showSeconds } = CountDown(state?.expiry);

  // *For Pagination
  const [pageLimit, setPageLimit] = useState(30);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Flash Sale Products 
  const [products, setProducts] = useState([]);

  // *For Get Flash Sales Products
  const getFlashSaleProducts = async (page, limit) => {
    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      setCurrentPage(Page)
      setPageLimit(Limit)
      let params = {
        search: '',
        page: Page,
        limit: Limit
      }
      const { data } = await ProductServices.getFlashSaleProducts(id, params)
      setProducts(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    getFlashSaleProducts()
  }, [id]);

  return (
    <Layout>
      <div className="flashsale-wrapper w-full">
        <div className="container-x mx-auto">
          <div className="w-full">
            <div
              style={{
                background: `url(${process.env.PUBLIC_URL}/assets/images/flash-sale-ads.png) no-repeat`,
                backgroundSize: "cover",
              }}
              data-aos="fade-right"
              className="flash-ad w-full h-[400px] flex sm:justify-end justify-center items-center mb-10"
            >
              <div className="sm:mr-[75px]">
                <div className="countdown-wrapper w-full flex sm:space-x-6 space-x-3 sm:justify-between justify-evenly">
                  <div className="countdown-item">
                    <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                      <span className="font-700 sm:text-[30px] text-base text-[#EB5757]">
                        {showDays}
                      </span>
                    </div>
                    <p className="sm:text-[18px] text-xs font-500 text-center leading-8 text-white">
                      Days
                    </p>
                  </div>
                  <div className="countdown-item">
                    <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                      <span className="font-700 sm:text-[30px] text-base text-[#2F80ED]">
                        {showHours}
                      </span>
                    </div>
                    <p className="sm:text-[18px] text-xs font-500 text-center leading-8 text-white">
                      Hours
                    </p>
                  </div>
                  <div className="countdown-item">
                    <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                      <span className="font-700 sm:text-[30px] text-base text-[#219653]">
                        {showMinutes}
                      </span>
                    </div>
                    <p className="sm:text-[18px] text-xs font-500 text-center leading-8 text-white">
                      Minutes
                    </p>
                  </div>
                  <div className="countdown-item">
                    <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                      <span className="font-700 sm:text-[30px] text-base text-[#EF5DA8]">
                        {showSeconds}
                      </span>
                    </div>
                    <p className="sm:text-[18px] text-xs font-500 text-center leading-8 text-white">
                      Seconds
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="products grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-5">
              {products?.map((item, index) => {
                const prod = { ...item, flashSaleId: id }
                return (
                  <div key={index} className="item">
                    <ProductCardStyleOne datas={prod} />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
